import ImportService from "../components/import_export/service/Import";
import ApiConstants from "../constants/ApiConstants";
import http from "../http";

class CheckhqService {
    static async getComponentLink(component) {
        return fetch(`${ApiConstants.URL.BASE}${ApiConstants.URL.CHECKHQ.GET_COMPONENT_LINK}/${component}`, ImportService.getApiRequestOptions("GET"))
            .then((response) => response.json())
            .catch((error) => Promise.reject(error));
    }

    static getCompanyAndIndustryType() {
        return http.get(`${ApiConstants.URL.BASE}${ApiConstants.URL.CHECKHQ.GET_COMPANY_AND_INDUSTRY_TYPE}`);
    }

    static syncCheckhqChanges(payload) {
        return http.post(`${ApiConstants.URL.BASE}${ApiConstants.URL.CHECKHQ.SYNC_CHANGES}`, payload);
    }
}

export default CheckhqService;
